class Newsletter{
    constructor() {
        this.newsletter = document.querySelector('.newsletter__form') || false;
        !this.newsletter || this.form_newsleter(this.newsletter);
        
    }

    form_newsleter(element) {
        element.querySelector('button').addEventListener('click', () => {
            let text = 'Musisz podać prawidłowy E-mail',
                checks = this.newsletter.querySelectorAll('input[type=checkbox]:checked');

            console.log(checks.length);
            
            if(checks.length === 2){
                if (this.validateEmail(element.querySelector('input').value)) {
                    !element.querySelector('.error_newsletter') || element.querySelector('.error_newsletter').remove();
                    this.ajaxEmail(element)
                } else {
                    this.errorValid(element, text);
                }
            }else{
                this.errorValid(element, 'Proszę o zaznaczenie wszystkich zgód');
            }
        });
    }

    ajaxEmail(element) {
        const http = new XMLHttpRequest(),
            url = AJAXURL,
            data = {
                action: 'newsleter_email',
                email: element.querySelector('input').value
            },
            params = this.converObc(data);
        http.open('POST', url, true);
        http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        http.onloadstart = () => element.querySelector('button').classList.add('load');
        http.onreadystatechange = () => {
            if (http.readyState == 4 && http.status == 200) {
                switch (http.response) {
                    case 'error':
                        this.errorValid(element, 'Coś poszło nie tak spróbuj ponowanie');
                        break;
                    case 'false':
                        this.errorValid(element, 'Wygląda na to że już jesteś z nami :)');
                        break;
                    case 'success':
                        this.errorValid(element, 'Twój adres e-mail został dopisany lub zaktualizowany. Sprawdź swoją skrzynkę e-mail.', true);
                        break;
                }

            }
        };
        http.onloadend = () => element.querySelector('button').classList.remove('load');
        http.send(params);
    }

    errorValid(element, text, cls = false) {
        if (element.querySelector('.error_newsletter')) {
            element.querySelector('.error_newsletter').innerText = text;
            !cls || element.querySelector('.error_newsletter').classList.add('succes');
        } else {
            let p = document.createElement('p');
            p.classList.add('error_newsletter');
            !cls || p.classList.add('succes');
            p.innerText = text;
            element.appendChild(p);
        }
    }
    validateEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }
    converObc(obc) {
        let html = '';
        for (let [key, value] of Object.entries(obc)) {
            if (typeof value === 'object') {
                let name = [];
                for (let [key1, value2] of Object.entries(value)) {
                    name.push(value2);
                }
                html += `${key}=${name}&`
            } else {
                html += `${key}=${value}&`
            }
        }
        return html.substring(0, html.length - 1);
    };
}
export default Newsletter;